"use client";
import * as React from "react";
const SvgFileDownloadRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.26 5.65H9.8V.95A.94.94 0 0 0 8.86 0H5.14a.94.94 0 0 0-.93.94v4.7H2.74c-.83 0-1.25 1.02-.66 1.62l4.26 4.32a.9.9 0 0 0 1.31 0l4.26-4.32c.59-.6.18-1.61-.65-1.61M.5 15.06c0 .52.42.94.93.94h11.14a.94.94 0 0 0 .93-.94.94.94 0 0 0-.93-.94H1.43a.94.94 0 0 0-.93.94" }));
export {
  SvgFileDownloadRound as default
};
